<template>
<!--  管理员-医疗机构员工修改-->
  <div class="login">
    <!-- 登录的操作部分 -->
    <div class="login-main">
      <div class="register">
        <div class="box-top">
          <div class="top-icon" @click="back">
            <img src="./assets/Arrow_Right_LG.png" alt="" />
          </div>
        </div>
        <div class="box-bottom">
          <div class="bottom-box-title">
            <p class="ja-welcom">
              <span>{{ $t("userModification") }}</span>
              <el-dropdown class="welcom-dropdown" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">{{ $t("chinese") }}</el-dropdown-item>
                  <el-dropdown-item command="1">{{ $t("japanese") }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
          </div>
          <!-- 表单部分 -->
          <div class="box-form">
            <!-- 头像选择 -->
            <div class="Avatar">
              <div class="Avatar-img" @click="toGetImg" v-if="!imageUrl">
                <p class="Avatar-img-icon">
                  <img src="./assets/Image_01.svg" alt="" />
                </p>
                <p class="Avatar-img-title">{{ $t("photograph") }}</p>
              </div>
              <div class="Avatar-img" @click="toGetImg" v-if="imageUrl">
                <img :src="imageUrl" alt="" class="Avatar-img-main-css" />
              </div>
            </div>
            <!-- 用户名input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("name") }}</p>
              <div class="emil-input-css">
                <img src="src/pages/adminEmployeeInformationModification/assets/User_01.svg" alt="" class="emil-icon" />
                <input
                  type="text"
                  name=""
                  id="userName"
                  v-model="userName"
                  class="emil-input-css-main"
                  @blur="registerData(4)"
                />
                <span v-if="userNameShow" class="emil-true-css">{{
                  $t("userNameRules")
                }}</span>
              </div>
            </div>
            <!-- 密码input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("password") }}</p>
              <div class="emil-input-css">
                <img src="src/pages/adminEmployeeInformationModification/assets//Vector.png" alt="" class="emil-icon" />
                <input
                  type="text"
                  id="passWordData"
                  class="emil-input-css-main"
                  v-model="passWordData"
                  @blur="registerData(2)"
                />
              </div>
              <span v-if="passWordShow" class="emil-true-css">{{
                  $t("passwordRules")
                }}</span>
            </div>
            <!-- 邮箱input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("emil") }}</p>
              <div class="emil-input-css">
                <img src="src/pages/adminEmployeeInformationModification/assets/Vector (1).png" alt="" class="emil-icon" />
                <input
                  type="text"
                  name=""
                  id="emilData"
                  class="emil-input-css-main"
                  v-model="emilData"
                  @blur="registerData(1)"
                />
              </div>
              <span v-if="emilShow" class="emil-true-css">{{
                $t("emilError")
              }}</span>
            </div>
            <!-- 担当案件数input -->
            <div class="emil-input">
              <p class="emil-input-title">{{$t("numberOfCases") }}</p>
              <div class="emil-input-css">
                <img src="src/pages/adminEmployeeInformationModification/assets/Vector.png" alt="" class="emil-icon" />
                <input
                  type="text"
                  id="casesNumberData"
                  class="emil-input-css-main"
                  v-model="casesNumberData"
                  @blur="registerData(5)"
                />
              </div>
              <span v-if="passWordShow" class="emil-true-css">{{
                $t("passwordRules")
              }}</span>
            </div>
          </div>
          <!-- 权限 -->
          <div >
            <p>{{ $t("limit") }}</p>
             <el-button  class="two-button" :class="{typeActive:type === 1}"  @click="checkoutType(1)" >管理员</el-button>
             <el-button  class="two-button button-margin" :class="{typeActive:type === 0}" @click="checkoutType(0)">用户</el-button>
          </div>
          <!-- 确定按钮 -->
          <div class="insure">
            <button class="insure-button" @click="toRegister">{{ $t("confirm") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {updateMedicalInstitutionUserInfo} from "../../js/api";
import AES from "../../js/AES";

export default {
  name: "adminEmployeeInformationModification",
  components: {},
  data() {
    return {
      imageUrl: "", //头像图片地址路径
      userName: "", //用户名
      userNameShow: false,
      emilData: "", //emil数据
      emilShow: false,
      passWordData: "", //密码数据
      casesNumberData:"",//担当案件数数据
      passWordShow: false,
      insurePassWordData: "", //确认密码数据
      insurePassWordShow: false,
      lang: "JP", //语言
      registrationSuccess: false, //注册成功标识
      registrationError: false, //注册失败标识
      type: 0,
      tableData:[],
    };
  },
  created() {
    this.tableData=this.$route.params.tableData
    this.getData();
  },
  computed: {},
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        this.getData();
      }
    },
    //获取旧数据
    getData(){
      console.log(this.tableData);
      this.userName=this.tableData.userName
      this.emilData=this.tableData.emailAddress
      this.casesNumberData=this.tableData.casesNumber
      this.type=this.tableData.applyAdmin
    },
    // input校验
    registerData(num) {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      var password = /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,18}$/;
      var userNameRule = /^.{4,32}$/;
      if (num === 1) {
        if (reg.test(this.emilData)) {
          this.emilShow = false;
        } else {
          this.emilShow = true;
        }
      } else if (num === 2) {
        if (password.test(this.passWordData)) {
          this.passWordShow = false;
        } else {
          this.passWordShow = true;
        }
      } else if (num === 3) {
        if (this.insurePassWordData !== this.passWordData) {
          this.insurePassWordShow = true;
        } else {
          this.insurePassWordShow = false;
        }
      } else if (num === 4) {
        if (userNameRule.test(this.userName)) {
          this.userNameShow = false;
        } else {
          this.userNameShow = true;
        }
      }
    },
    //语言转换
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
      }
    },
    toRegister(){
      var fakeInfo={
        applyAdmin: this.type,
        avatar: this.avatar,
        casesNumber: this.casesNumber,
        emailAddress: this.emailAddress,
        ip: this.ip,
        medicalId: this.medicalId,
        password: this.password,
        reviewStatus: this.reviewStatus,
        userId: this.userId,
        userName: this.userName,
        userStatus: 0
      }
      updateMedicalInstitutionUserInfo(fakeInfo).then((res) => {
        console.log("-----更新医疗机构用户-----");
        console.log(res);
      }).catch( (res) =>{})
    },
    checkoutType(index) {
      if (index === 1 || index === 0) {
        this.type = index
        console.log(this.type);
      }else {
        this.sort = index
      }
    },
    back(){
      this.$router.push("/administratorsOnlyMedicalListStaffManagement");
    },
    //上传图片
    toGetImg() {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 2;
        const size = files.size / 1024 / 1024;
        console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error(this.$t("imageSize"));
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error(this.$t("selectImage"));
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function () {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.imageUrl = this.result;
            console.log(this.result);
            // 数据传到后台
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            console.log(formData.get("file"));
          };
        }
      }
    },
  },
};
</script>
<style scoped>
.emil-true-css {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  box-sizing: border-box;
  display: inline-block;
  margin-left: 10px;
  color: #f56c6c;
}
.login {
  width: 100vw;
  height: 100vh;
  background: #51abff;
  display: flex;
}
.login-dialog {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}
.dialog-main {
  width: 498px;
  height: 266px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);
}
.dialog-main img {
  width: 66px;
  height: 66px;
  margin-bottom: 30px;
  margin-top: 37px;
}
.dialog-main p {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
}
.dialog-button {
  margin-top: 30px;
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  cursor: pointer;
}
.dialog-button1 {
  margin-top: 30px;
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #fc630c;
  cursor: pointer;
}
.login-main {
  flex: 1;
  background: #ffffff;
  position: relative;
}
.register {
  background: #ffffff;
  border: 2px solid #ececec;
  box-sizing: border-box;
  border-radius: 8px;
  width: 404px;
  height: 668px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -202px;
  margin-top: -334px;
}
.box-top {
  height: 50px;
  line-height: 50px;
  width: 100%;
}
.top-icon {
  width: 50px;
  height: 50px;
  float: right;
  text-align: center;
  cursor: pointer;
}
.box-bottom {
  height: 618px;
  padding: 0 40px;
}
.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 26px;
}
.ja-welcom {
  width: 100%;
  height: 32px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #212429;
}
.welcom-dropdown {
  padding-top: 15px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  line-height: 16px;
  letter-spacing: 0.639063px;
  color: #686868;
  margin-left: 5px;
}
.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.box-form {
  margin-top: 20px;
}
.emil-input {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-bottom: 10px;
}
.emil-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}
.emil-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 320px;
  box-sizing: border-box;
}
.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}
.emil-input-css-main {
  width: 250px;
  height: 38px;
  line-height: 38px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}
.two-button {
  margin-top: 8px;
  border-radius: 24px;
  width: 150px;
  height: 40px;
}
.two-button button {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  width: 150px;
  height: 40px;
  background: #fff;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-right: 8px;
}
.button-margin {
  margin: 0;
}
.agree {
  margin-top: 30px;
  text-align: center;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  align-items: center;
  letter-spacing: -0.02em;
  color: #c9cfda;
}
.insure {
  height: 50px;
  margin-top: 13px;
  margin-bottom: 10px;
}
.insure-button {
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 320px;
  height: 50px;
}
.typeActive button{
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  width: 150px;
  height: 40px;
  background: #51abff;
  color: #fff;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-right: 8px;
}
.Avatar-img {
  margin-top: 12px;
  width: 90px;
  height: 90px;
  background: #51abff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
  align-content: center;
}
.Avatar-img-icon {
  margin-top: 15px;
}
.Avatar-img-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.Avatar-img .Avatar-img-main-css {
  width: 90px;
  height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/pages/adminEmployeeInformationModification/index.vue